/**
 * useAnalyticsPageView — V2.M.2
 *
 * Auto-emits a page_view event whenever the route changes.
 * Use ONCE inside an authenticated React Router subtree
 * (typically <AppContent />). Subsequent mounts are harmless but
 * waste cycles.
 *
 * Skipped on the initial mount of an empty path — React Router
 * sometimes fires a transient location with no path before the first
 * navigation. We track the first real path then everything after it.
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/analyticsTracker';

export function useAnalyticsPageView() {
  const location = useLocation();
  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname;
    if (!path) return;
    if (lastPathRef.current === path) return;
    lastPathRef.current = path;
    const title = typeof document !== 'undefined' ? document.title : undefined;
    void trackPageView(path, title);
  }, [location.pathname]);
}
